import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

const PHASES = ["Inspirez", "Gardez", "Expirez"];

export default function InstantOverlay({ open, needLabel, minutes, onClose, onContinue }) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    if (!open) return undefined;
    setPhase(0);
    const timer = setInterval(() => setPhase((p) => (p + 1) % PHASES.length), 3200);
    const advance = setTimeout(() => onContinue?.(), 3000);
    return () => {
      clearInterval(timer);
      clearTimeout(advance);
    };
  }, [open, onContinue]);

  // Cercle synchronisé sur le souffle : Inspirez → se gonfle, Gardez → reste plein, Expirez → se dégonfle
  const breathScale = phase === 2 ? 1 : 1.25;
  const breathTransition = { duration: 3.2, ease: phase === 1 ? "linear" : "easeInOut" };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="rav-overlay"
          data-testid="instant-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
        >
          <button
            type="button"
            className="rav-overlay-close"
            data-testid="instant-overlay-close"
            aria-label="Fermer"
            onClick={onClose}
          >
            <X size={19} strokeWidth={1.5} />
          </button>
          <motion.p
            className="rav-overlay-kicker"
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          >
            Votre instant se prépare…
          </motion.p>
          <motion.div
            className="rav-breath"
            data-testid="breath-circle"
            animate={{ scale: breathScale }}
            transition={breathTransition}
          >
            <div className="rav-breath-inner" />
          </motion.div>
          <AnimatePresence mode="wait">
            <motion.p
              key={phase}
              className="rav-breath-phase"
              data-testid="breath-phase"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.8 }}
            >
              {PHASES[phase]}
            </motion.p>
          </AnimatePresence>
          <p className="rav-overlay-summary" data-testid="instant-summary">
            {needLabel} · {minutes} min
          </p>
          <button
            type="button"
            className="rav-primary-button rav-overlay-cta"
            data-testid="instant-continue-button"
            onClick={onContinue}
          >
            Continuer
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
